import React from "react";
import Icon from "../icon/icon";

export interface IMyListsHeaderProps {
  myListsUrl: string | undefined;
  displayUserInfo: boolean;
  onClick: () => void;
}

const MyListsHeaderClient = (props: IMyListsHeaderProps) => {
  const myListsProperties: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > = {};
  if (props.myListsUrl) {
    myListsProperties.href = props.myListsUrl;
  } else {
    myListsProperties.onClick = props.onClick;
  }
  return (
    <>
      {props.displayUserInfo ? (
        <a
          className="d-inline-block panel-item panel-item-margin active"
          tabIndex={0}
          {...myListsProperties}
        >
          <Icon>favorite_border</Icon>
          <span className="panel-label">Lists</span>
        </a>
      ) : (
        <span
          className={"d-inline-block panel-item panel-item-margin invisible"}
        >
          <Icon>favorite_border</Icon>
          <span className="panel-label">Lists</span>
        </span>
      )}
    </>
  );
};

export default MyListsHeaderClient;
